export const locales = [
  "pl", "en", "de", "cs", "lt", "no", "ru"
]
